import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';
import { addMembers } from './admin/addMembers';
import { designAndConfiguration } from './admin/designAndConfiguration';
import { notificationsAndDigests } from './admin/notificationsAndDigests';
import { data } from './admin/data';
import { securityAndAccess } from './admin/securityAndAccess';
import { learning } from './admin/learning';
import { memberManagement } from './admin/memberManagement';
import { eventCreate } from './admin/eventCreate';

export const admin: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('groups.admin.main.title') as string;
			},
			trappRoute(to: Route): string {
				return `/sgdp.shtml?hcgd=${to.params.groupId}`;
			},
		},
		path: 'admin',
		name: Routes.GROUP_ADMIN,
		redirect: { name: Routes.GROUP_ADMIN_MEMBER_MANAGEMENT },
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				groupId: route.params.groupId,
			};
		},
		component: () => import(/* webpackChunkName: "group-admin" */ '@front-app/views/home/group/admin/AdminMain.vue'),
		children: [
			...memberManagement,
			...addMembers,
			...securityAndAccess,
			...designAndConfiguration,
			...notificationsAndDigests,
			...data,
			...learning,
			...eventCreate,
		],
	},
];
